module.exports = __webpack_public_path__ + "static/GilroyAlt-SemiBold-17ca962efcfcd35633bbba7427e1a8b2.woff";